import { assignIfExists } from '@/utils/resultsHelper';
import withDraft from '@/utils/draftHelper';
import { states } from '@/constants/lifecycle';
import { responseError } from '@/utils/errors';
import fetchClausesCountsState, { fetchClauseCountsState } from './shared';
import { findQueryClause, findQueryProfile } from '../../state/shared';
import actions from '../constants';

const fetchClauseCounts = withDraft((draft, action) => { fetchClauseCountsState(draft, action); });

const showClauseCounts = withDraft((draft, action) => {
  const { clause } = findQueryClause(draft.cohorts, action);
  if (clause) {
    assignIfExists(clause.profile, {
      total: action.total,
      totalFiltered: action.totalFiltered,
      entities: action.entities,
      readStatus: states.SUCCESS,
      readErrors: [],
    });
  }
});

const showClauseCountsError = withDraft((draft, action) => {
  const { clause } = findQueryClause(draft.cohorts, action);
  if (clause) {
    clause.profile.readStatus = states.ERROR;
    clause.profile.readErrors = [responseError(action)];
  }
});

const showClauseCountsCancelled = withDraft((draft, action) => {
  const { clause } = findQueryClause(draft.cohorts, action);
  if (clause) {
    clause.profile.readStatus = states.NONE;
    clause.profile.readErrors = [];
  }
});

const toggleClauseCounts = withDraft((draft, action) => {
  const { clause } = findQueryClause(draft.cohorts, action);
  if (clause) {
    clause.profile.showCounts = !clause.profile.showCounts;
  }
});

const fetchClausesCounts = withDraft((draft, action) => { fetchClausesCountsState(draft, action); });

const showClausesCounts = withDraft((draft, action) => {
  const { profile } = findQueryProfile(draft.cohorts, action);
  assignIfExists(profile, {
    total: action.total,
    totalFiltered: action.totalFiltered,
    entities: action.entities,
    readStatus: states.SUCCESS,
    readErrors: [],
  });
});

const showClausesCountsError = withDraft((draft, action) => {
  const { profile } = findQueryProfile(draft.cohorts, action);
  profile.readStatus = states.ERROR;
  profile.readErrors = [responseError(action)];
});

const showClausesCountsCancelled = withDraft((draft, action) => {
  const { profile } = findQueryProfile(draft.cohorts, action);
  profile.readStatus = states.NONE;
  profile.readErrors = [];
});

const toggleClausesCounts = withDraft((draft, action) => {
  const { profile } = findQueryProfile(draft.cohorts, action);
  profile.showCounts = !profile.showCounts;
});

export default {
  [actions.FETCH_CLAUSE_COUNTS]: fetchClauseCounts,
  [actions.FETCH_CLAUSES_COUNTS]: fetchClausesCounts,
  [actions.SHOW_CLAUSE_COUNTS]: showClauseCounts,
  [actions.SHOW_CLAUSE_COUNTS_CANCELLED]: showClauseCountsCancelled,
  [actions.SHOW_CLAUSE_COUNTS_ERROR]: showClauseCountsError,
  [actions.SHOW_CLAUSES_COUNTS]: showClausesCounts,
  [actions.SHOW_CLAUSES_COUNTS_CANCELLED]: showClausesCountsCancelled,
  [actions.SHOW_CLAUSES_COUNTS_ERROR]: showClausesCountsError,
  [actions.TOGGLE_CLAUSE_COUNTS]: toggleClauseCounts,
  [actions.TOGGLE_CLAUSES_COUNTS]: toggleClausesCounts,
};
